<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('Surveys') }}</div>
            <v-card-text>
                <v-card-title>
                    <v-text-field v-model="search" class="me-8" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />
                    <v-checkbox v-model="isShared" class="mt-4 ms-8" :label="$t('IsShared')" hide-details></v-checkbox>
                    <v-checkbox v-model="showOnHomePage" class="mt-4 ms-8" :label="$t('ShowOnHomePage')" hide-details></v-checkbox>
                    <v-checkbox v-model="isPublished" class="mt-4 ms-8" :label="$t('Published')" hide-details></v-checkbox>
                    <v-checkbox v-model="active" class="mt-4 ms-8" :label="$t('Active')" hide-details></v-checkbox>

                    <v-spacer />
                    <router-link :to="{ name: 'add-survey'}" custom>
                        <v-btn fab small class="white--text" color="secondary" role="link">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </router-link>
                </v-card-title>
                <v-data-table :headers="headers" dense :items="filteredList" :search="search" class="mt-6" @dblclick:row="(event, { item }) => editSurvey(item.id)">
                    <template v-slot:[`item.nameAr`]="{ item }">
                        {{ RemoveHtmlTags(item.nameAr) }}
                    </template>
                    <!--<template v-slot:[`item.nameEn`]="{ item }">
                        {{ RemoveHtmlTags(item.nameEn) }}
                    </template>-->
                    <template v-slot:[`item.expiryDate`]="{ item }">
                        {{ item.expiryDate | formatDateGregorian }}
                    </template>
                    <template v-slot:[`item.startDate`]="{ item }">
                        {{ item.startDate | formatDateGregorian }}
                    </template>
                    <template v-slot:[`item.expired`]="{ item }">
                        <v-icon v-if="item.expired" color="error">mdi-close</v-icon>
                        <v-icon v-else color="primary">mdi-check</v-icon>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip small :class="`${item.status.toLowerCase()}`" :color="item.status.toLowerCase() == 'approved'?'primarylight':''">{{ $t(item.status) }}</v-chip>
                    </template>
                    <template v-slot:[`item.isPublished`]="{ item }">
                        <v-icon v-if="item.isPublished" color="teal">mdi-check</v-icon>
                        <v-icon v-else color="error">mdi-close</v-icon>
                    </template>
                    <template v-slot:[`item.hasTrickyQuestion`]="{ item }">
                        <v-icon v-if="item.hasTrickyQuestion" color="teal">mdi-check</v-icon>
                        <v-icon v-else color="error">mdi-close</v-icon>
                    </template>
                    <template v-slot:[`item.showOnHomePage`]="{ item }">
                        <v-icon v-if="item.showOnHomePage" color="teal">mdi-check</v-icon>
                        <v-icon v-else color="error">mdi-close</v-icon>
                    </template>
                    <template v-slot:[`item.isShared`]="{ item }">
                        <v-icon v-if="item.isShared" color="teal">mdi-check</v-icon>
                        <v-icon v-else color="error">mdi-close</v-icon>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <table>
                            <tr>
                                <td v-if="item.statusId == approved" style="padding:10px">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <router-link :to="{ name: 'survey-results', params: { id: item.id }}">
                                                <v-icon color="secondary" role="link" v-bind="attrs" v-on="on">mdi-list-box-outline</v-icon>
                                            </router-link>
                                        </template>
                                        <span>{{ $t('Results') }}</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="item.statusId == approved" style="padding:10px">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <router-link :to="{ name: 'survey-analytics', params: { id: item.id }}">
                                                <v-icon color="primary" role="link" v-bind="attrs" v-on="on">mdi-chart-areaspline</v-icon>
                                            </router-link>
                                        </template>
                                        <span>{{ $t('Analytics') }}</span>
                                    </v-tooltip>
                                </td>
                                <td style="padding:10px">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon color="black" v-bind="attrs" v-on="on" @click="genrateQrCode(item.id,item.isShared,getTitle(item))">mdi-qrcode-scan</v-icon>
                                        </template>
                                        <span>{{ $t('QrCode') }}</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="item.isPublished" style="padding:10px">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <router-link :to="{ name: 'share-survey', query: { id: item.id }}">
                                                <v-icon color="darkGrey" class="mx-1" v-bind="attrs" v-on="on">mdi-share</v-icon>
                                            </router-link>
                                        </template>
                                        <span>{{ $t('Share') }}</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="item.isPublished" style="padding:10px">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <router-link :to="{ name: 'add-survey', query: { id: item.id }}">
                                                <v-icon color="darkGrey" class="mx-1" v-bind="attrs" v-on="on">mdi-eye</v-icon>
                                            </router-link>
                                        </template>
                                        <span>{{ $t('View') }}</span>
                                    </v-tooltip>
                                </td>
                                <td v-if="item.statusId == draft" style="padding:10px">
                                    <router-link class="mx-3" :to="{ name: 'add-survey', query: { id: item.id }}">
                                        <v-icon color="primary" role="link">mdi-pencil</v-icon>
                                    </router-link>
                                </td>
                                <td v-if="item.statusId == draft" style="padding:10px">
                                    <v-icon color="error" @click="removeSurvey(item.id)">mdi-delete</v-icon>
                                </td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:[`item.options`]="{ item }">
                        <router-link class="mx-3" :to="{ name: 'add-survey', query: { id: item.id }}" v-if="item.statusId == draft">
                            <v-icon color="primary" role="link">mdi-pencil</v-icon>
                        </router-link>
                        <v-icon color="error" @click="removeSurvey(item.id)" v-if="item.statusId == draft">mdi-delete</v-icon>
                    </template>

                    <template v-slot:[`item.menu`]="{ item }">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list>

                                <v-list-item @click="copy(item.id)">
                                    <v-list-item-icon>
                                        <v-icon color="black">mdi-content-copy</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $t('Copy') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="generateHtml(item.id)">
                                    <v-list-item-icon>
                                        <v-icon color="black">mdi-xml</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $t('CopyHTML') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="makeCopy(item.id)">
                                    <v-list-item-icon>
                                        <v-icon color="black">mdi-receipt-text-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $t('MakeCopy') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="exportToEdit(item.id)">
                                    <v-list-item-icon>
                                        <v-icon color="black">mdi-microsoft-excel</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $t('EditAnswersInExcel') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
                <ManageQrCode v-model="qrCodeDialog" :surveyURL="surveyURL" :title="selectedTitle" />
                <!--<CommonDialog v-model="qrCodeDialog" :fullscreen="false" width="500" :title="selectedTitle" css-content-class="pa-0" @input="qrCodeDialog= false">
        <div style="text-align:center" class="pa-4">
            <qrcode-vue ref="qrcode" :value="surveyURL" size="150" level="H" />
            <div class="text-center">
                <v-checkbox v-model="isSharedQrForm" @change="shareSurvey" :label="$t('IsShared')"></v-checkbox>
            </div>
            <v-btn @click="downloadQR" color="secondary">{{$t('DOWNLOADQRCODE')}}</v-btn>
        </div>

    </CommonDialog>-->
                <CommonDialog v-if="showExcelEditor" v-model="showExcelEditor" :fullscreen="false" :title="$t('EditAnswersInExcel')">
                    <ExcelEditor v-model="selectedSurveyId"></ExcelEditor>
                </CommonDialog>
            </v-card-text>
        </v-card>
    </v-container></template>

<script lang="ts">
    import ManageQrCode from '@/components/app/admin/survey/ManageQrCode.vue'
    import { mapGetters } from 'vuex'
    import SurveyService from '@/services/SurveyService.js'
    import UsersService from '@/services/UsersService.js'
    import { SurveyStatusEnum } from '@/helpers/constants/enumerations.js'
    import CommonDialog from '@/components/controls/CommonDialog'
    //import QrcodeVue from 'qrcode.vue'
    import domtoimage from 'dom-to-image'
    import { useStripHtml } from '@/helpers/common.js'
    import ExcelEditor from '@/components/controls/ExcelEditor.vue'

    export default {
        components: {
            CommonDialog,/*, QrcodeVue,*/ ManageQrCode, ExcelEditor
        },

        data() {
            return {
                search: '',
                selectedSurveyId: 0,
                loading: false,
                enabled: false,
                isShared: null,
                isSharedQrForm: null,
                isPublished: null,
                active: null,
                showOnHomePage: null,
                surveys: [],
                mainSurveyList: [],
                userPermissionsList: [],
                showExcelEditor: false,
                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('NameAr'), value: 'nameAr' },
                    //{ text: this.$t('NameEn'), value: 'nameEn' },
                    { text: this.$t('Published'), value: 'isPublished', align: 'center' },
                    { text: this.$t('ShowOnHomePage'), value: 'showOnHomePage', align: 'center' },
                    { text: this.$t('HasTrickyQuestion'), value: 'hasTrickyQuestion', align: 'center' },
                    { text: this.$t('Active'), value: 'expired' },
                    { text: this.$t('IsShared'), value: 'isShared' },
                    { text: this.$t('CreatedBy'), value: 'createdByName' },
                    { text: this.$t('StartDate'), value: 'startDate' },
                    { text: this.$t('ExpiryDate'), value: 'expiryDate' },
                    { text: this.$t('Status'), value: 'status' },
                    { text: this.$t('Actions'), value: 'actions' },
                    { text: '', value: 'menu' },

                ],
                selectedItem: null,
                draft: SurveyStatusEnum.Draft,
                approved: SurveyStatusEnum.Approved,
                qrCodeDialog: false,
                surveyURL: '',
                selectedTitle: ''

            }
        },

        created() {
            this.listSruveys()
        },
        mounted() {
            this.hasUpdatePermission()
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
            filteredList() {
                return this.surveys.filter(task => (this.showOnHomePage == null || this.showOnHomePage == false || task.showOnHomePage == this.showOnHomePage)
                    && (this.isShared == null || task.isShared == this.isShared || this.isShared == false)
                    && (this.isPublished == null || task.isPublished == this.isPublished || this.isPublished == false)
                    && (this.active == null || task.expired != this.active || this.active == false)
                )
            }
        },
        methods: {
            downloadQR() {
                // Reference to the qrcode-vue component
                const qrcodeEl = this.$refs.qrcode.$el

                // Convert the SVG element to a data URL
                domtoimage.toPng(qrcodeEl)
                    .then(dataUrl => {
                        // Create a link element
                        const link = document.createElement('a')
                        link.href = dataUrl
                        link.download = 'qrcode.png'

                        // Simulate click on the link to trigger download
                        link.click()
                    })
                    .catch(error => {
                        console.error('Error while converting QR code to image:', error)
                    })
            },
            shareSurvey(value) {
                this.loading = true
                SurveyService.shareSurvey(this.selectedSurveyId, value).then((res) => {
                    this.listSruveys()
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            getTitle(question) {
                return this.language == 'ar' || this.language == null ? question.nameAr : question.nameEn
            },
            hasUpdatePermission() {
                UsersService.listCurrentUserPermissions().then((res) => {
                    if (res.data) {
                        this.userPermissionsList = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            handleAction(action, item) {
                switch (action.action) {
                    case 'edit':
                        this.editSurvey(item.id)
                        break
                    case 'delete':
                        this.removeSurvey(item.id)
                        break
                    case 'results':
                        this.resultsSurvey(item.id)
                        break
                    case 'view':
                        this.editSurvey(item.id)
                        break
                    case 'copy':
                        this.copy(item.id)
                        break
                    case 'copyHtml':
                        this.generateHtml(item.id)
                        break
                    case 'analytics':
                        this.surveyAnalytics(item.id)
                        break
                    case 'qrCode':
                        this.genrateQrCode(item.id)
                        break
                    case 'makeCopy':
                        this.makeCopy(item.id)
                        break
                    default:
                        break
                }
            },
            editSurvey(id) {
                this.$router.push({ name: 'add-survey', query: { id } })
            },
            resultsSurvey(id) {
                this.$router.push({ name: 'survey-results', query: { id } })
            },
            surveyAnalytics(id) {
                this.$router.push({ name: 'survey-analytics', query: { id } })
            },

            listSruveys() {
                this.loading = true
                SurveyService.listSurveys(false).then((res) => {
                    this.surveys = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            copy(itemId) {
                navigator.clipboard.writeText(window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + `/form/${itemId}`)
                this.$root.$notification(this.$t('CopySucceeded'), 'success')
            },
            generateHtml(itemId) {
                var url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + `/form/${itemId}`
                var html = `<iframe id="myIframe" src = '${url}' > </iframe>`
                navigator.clipboard.writeText(html)
                this.$root.$notification(this.$t('CopySucceeded'), 'success')
            },
            genrateQrCode(itemId, isShared, title) {
                this.selectedSurveyId = itemId
               // this.isShared = isShared
                this.surveyURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + `/form/${itemId}`
                this.qrCodeDialog = true
                this.isSharedQrForm = isShared
                this.selectedTitle = title
            },

            async removeSurvey(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    SurveyService.deleteSurvey(id)
                        .then((res) => {
                            this.listSruveys()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('SurveyInProcess'), 'error')
                        }).finally(() => this.loading = false)
                }
            },
            exportToEdit(surveyId) {
                this.selectedSurveyId = surveyId
                this.showExcelEditor = true
            },
            async makeCopy(surveyId) {

                if (await this.$root.$confirm(this.$t('MakeCopy'), this.$t('Are you sure you want to make a copy of this Survey ?'))) {
                    this.loading = true
                    SurveyService.loadSurveywithoutAuth(surveyId).then((res) => {
                        this.survey = res.data
                        this.survey.id = null
                        this.survey.isPublished = false
                        SurveyService.copySurvey(this.survey).then((res) => {
                            this.$router.push('/add-survey?id=' + res.data)
                        }).catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => {
                            this.loading = false
                        })
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })

                }
            },
            RemoveHtmlTags(text) {
                return useStripHtml(text)
            },

            filterGrid(e) {

                if (e) {
                    this.mainSurveyList = this.surveys
                    switch (e.value) {
                        case 'isShared':
                            this.surveys = this.surveys.filter(x => x.isShared == true)
                            break
                        case 'showOnHomePage':
                            this.surveys = this.surveys.filter(x => x.showOnHomePage == true)
                            break
                        case 'isPublished':
                            this.surveys = this.surveys.filter(x => x.isPublished == true)
                            break
                        case 'active':
                            this.surveys = this.surveys.filter(x => x.expired == false)
                            break
                        default:
                    }
                }
                else {
                    this.surveys = this.mainSurveyList
                }
            }
        }
    }
</script>

<style scoped>
    .v-chip.draft {
        background: #dedede;
    }

    .v-chip.pending {
        background: #ffaa2c;
    }

    .v-chip.approved {
        background: var(--v-secondary-base);
        color: #07706d
    }

    ::v-deep .v-data-table tbody tr {
        cursor: pointer;
    }
</style>